import { IconButton } from "@mui/material"
import { styled } from "@mui/styles"

export const StyledIconButton = styled(IconButton)(({ size, color }) => ({
  "&[class*=MuiIconButton-root]": {
    color: color === "default"
      ? "#333333"
      : color
  },

  ...size === "medium" && medium,
  ...size === "small" && small
}))

const medium = {
  height: "32px",
  width: "32px"
}

const small = {
  height: "18px",
  width: "18px",

  "& svg": {
    fontSize: "18px"
  }
}
